import { useQuery } from "@tanstack/react-query";
import { fetchLocalisationKeys } from "PFCore/services/admin/localisation/fetch_localisation_keys";
import { Id } from "PFTypes";
import { LocalisationKeys } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import api from "../../../../api";
import { queryKeys } from "./query_keys";

export const useLocalisationExport = (
  accountId: Id,
  key: LocalisationKeys,
  locales?: string[],
  options?: QueryOptions<string>
) =>
  useQuery(
    queryKeys.localisationExport(accountId, key, locales),
    async () => {
      let fileUrl;

      while (!fileUrl) {
        const exportData = await fetchLocalisationKeys({ accountId, key, format: "csv", locales });
        ({ fileUrl } = exportData);

        if (!fileUrl) {
          await new Promise((resolve) => setTimeout(resolve, 1000)); // wait 1 sec for refetch
        }
      }

      // Fetch S3 file link
      const pathname = new URL(fileUrl).pathname.replace("/api/", "");
      const { fileUrl: s3FileUrl } = await api({ url: pathname });

      return s3FileUrl;
    },
    options
  );
